var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"section",attrs:{"id":"gallery"}},[_c('v-container',[_c('h1',[_vm._v("Gallery "+_vm._s(_vm.type))]),_c('galleryBlock',{attrs:{"directory":_vm.type,"number":_vm.number}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }